import { USER } from '~/consts'

export default async function ({ store, redirect, app, error, route }) {
  const cookies = app.$cookies;
  const token = helpers.isEmpty(route.query.t) ? cookies.get('token') : route.query.t;
  let auth = store.state.auth

  if (!auth) {
    // GET USER DATA
    let data = null
    try {
      let res = await app.$axios.post(USER.GET_PROFILE);
      data = res.data
    } catch ({ response }) {
      return error({ statusCode: 401 })
    }

    if (!helpers.isEmpty(data) && data.applicationSystem.code == 9) {
      store.commit('setState', { key: 'maintenance_message', value: data.applicationSystem.message })

      return redirect('/maintenance');
    }

    if (!(!helpers.isEmpty(data) && !helpers.isEmpty(data.data) && data.applicationSystem.code == 0)) {
      store.commit('clearAuth');

      return redirect('/login');
    }

    auth = data.data;
  }

  auth['is_admin'] = auth.email == 'edlink.sevima@gmail.com';
  store.commit('setAuth', auth);
}
